// extracted by mini-css-extract-plugin
export default {"badge":"SectionBadge_badge__uzi-9","icon":"SectionBadge_icon__z2QF2","text":"SectionBadge_text__kcMmp"};